export const SET_SHOW_PREVIEW =  "SET_SHOW_PREVIEW";
export const GET_WIDGETS_CONFIG = "GET_WIDGETS_CONFIG";
export const GET_WIDGETS_PUBLISH = "GET_WIDGETS_PUBLISH";
export const GET_REVIEWS = "GET_REVIEWS";
export const GET_REVIEWS_FILTERED = "GET_REVIEWS_FILTERED";
export const GET_REVIEWS_FILTERED_SUCCESS = "GET_REVIEWS_FILTERED_SUCCESS";
export const GET_REVIEWS_CONFIG = "GET_REVIEWS_CONFIG";
export const GET_WIDGETS_HTML_CALLS = "GET_WIDGETS_HTML_CALLS";
export const GET_OVERALL_RATING = "GET_OVERALL_RATING";
export const GET_WIDGETS_CONFIG_SUCCESS= "GET_WIDGETS_CONFIG_SUCCESS";
export const GET_WIDGETS_PUBLISH_SUCCESS= "GET_WIDGETS_PUBLISH_SUCCESS";
export const GET_REVIEWS_SUCCESS = "GET_REVIEWS_SUCCESS"
export const GET_REVIEWS_CONFIG_SUCCESS = "GET_REVIEWS_CONFIG_SUCCESS";
export const GET_WIDGETS_HTML_CALLS_SUCCESS= "GET_WIDGETS_HTML_CALLS_SUCCESS";
export const GET_OVERALL_RATING_SUCCESS = "GET_OVERALL_RATING_SUCCESS";
export const GET_WIDGETS_CONFIG_ERROR= "GET_WIDGETS_CONFIG_ERROR";
export const GET_WIDGETS_PUBLISH_ERROR= "GET_WIDGETS_PUBLISH_ERROR";
export const GET_WIDGETS_HTML_CALLS_ERROR = "GET_WIDGETS_HTML_CALLS_ERROR";
export const SAVE_WIDGETS_CONFIG = "SAVE_WIDGETS_CONFIG";
export const SAVE_WIDGETS_CONFIG_SUCCESS= "SAVE_WIDGETS_CONFIG_SUCCESS";
export const SAVE_WIDGETS_CONFIG_ERROR= "SAVE_WIDGETS_CONFIG_ERROR";
export const SAVE_WIDGETS_PUBLISH = "SAVE_WIDGETS_PUBLISH";
export const SAVE_WIDGETS_PUBLISH_SUCCESS= "SAVE_WIDGETS_PUBLISH_SUCCESS";
export const SAVE_WIDGETS_PUBLISH_ERROR= "SAVE_WIDGETS_PUBLISH_ERROR";
export const GET_PROVIDERS_RATING = "GET_PROVIDERS_RATING";
export const GET_PROVIDERS_RATING_SUCCESS = "GET_PROVIDERS_RATING_SUCCESS";
export const GET_PROVIDERS_RATING_ERROR = "GET_PROVIDERS_RATING_ERROR";
export const SET_SELECTED_TAB_CONFIG = "SET_SELECTED_TAB_CONFIG";
